<template>
	<BaseCmsPage v-slot="{page}" @load="onPageLoad">
		<h1 style="display: none" v-if="page?.seo_title">{{ page.seo_title }}</h1>
		<CmsHeroSlider />
		<CmsHomepagePromoFeatured />

		<div class="wrapper">
			<CmsBenefits />
			<LazyCatalogCategories hydrate-on-visible />
		</div>

		<LazyCatalogHomepageSpecialOffers hydrate-on-visible />
		<LazyCatalogHomepageSpecialList hydrate-on-visible />
		<LazyCmsHomepageSpecialOffers hydrate-on-visible />
		<CatalogHomepageLists />
		<LazyCmsHomepagePromo hydrate-on-visible />
	</BaseCmsPage>
</template>

<script setup>
	const {gtmTrack} = useGtmBB();
	function onPageLoad(data) {
		if(!data) return;
		gtmTrack('virtualPageview', {
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>


<style lang="less">	
	.promo-read-more{
		background: var(--gray2); font-size: 18px; font-weight: bold; border-radius: var(--borderRadius); display: flex; flex-direction: column; gap: 15px; align-items: center; justify-content: center; text-decoration: none; height: calc(~"50% - 12px"); flex-shrink: 0; flex-grow: 0; color: var(--textColor); transition: background 0.3s, color 0.3s;
		@media (max-width: @m){height: calc(~"50% - 6px");}
		&:hover{background: var(--blue); color: #fff; text-decoration: none;}
		&:before{.icon-frame(); font: 55px/1 var(--fonti); display: block;}
	}
</style>

